import { render, staticRenderFns } from "./AddClosuresSlotForm.vue?vue&type=template&id=396d13f2"
import script from "./AddClosuresSlotForm.vue?vue&type=script&lang=ts"
export * from "./AddClosuresSlotForm.vue?vue&type=script&lang=ts"
import style0 from "./AddClosuresSlotForm.vue?vue&type=style&index=0&id=396d13f2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports